const LoadingSpinner = () => {
  return (
    <div className="loader" role="status">
      Loading…
    </div>
  );
};

export default LoadingSpinner;
